module.exports = __webpack_public_path__ + "static/media/plus.be9a8c9e.svg";